export const insuranceCompanyEunm = [
  {
    stateId: "中国平安财产保险股份有限公司",
    stateName: "中国平安财产保险股份有限公司"
  },
]